import React from 'react'
import Header from 'components/Header'
import history from '../history'
import Utils from '../Utils'
import QuestionInit from '../components/consult/QuestionInit'
import 'style/QuestionPreview.css'

class QuestionPreview extends React.Component {
    state = {
        message: '',
        time: '',
        date: '',
        title: ''
    }

    componentDidMount() {
        const { consultRequest: { question, createdAt, ConsultCategory, doctor } } = this.props.location.state

        console.log(ConsultCategory)

        this.setState({
            doctor:doctor,
            ConsultCategory,
            message: question,
            time: Utils.timeStampToHHMM(createdAt),
            date: Utils.timeStampToDDMM(createdAt),
            title: ConsultCategory && ConsultCategory.name ? `مشاوره ${ConsultCategory.name}` :
                doctor ? `دکتر ${doctor.fname + ' ' + doctor.lname}` : 'منتظر پاسخ دکتر'
        })
    }

    onBack = () => {
        history.goBack()
    }

    render() {
        return (
            <>
                <Header title={this.state.title} showBackButton onBack={this.onBack} />
                <div className="qeustinPreviewContainer">
                    <div className="background"></div>
                    <div className="psudo">
                        <QuestionInit doctor={this.state.doctor} consultCategory={this.state.ConsultCategory} />
                        <div className="MessageRow">
                            <div className="date">{this.state.date}</div>
                        </div>
                        <div className="MessageRow">
                            <div className="ChatMessage Mine">
                                <span className="text">{this.state.message}</span>
                                <div className="chatTime">{this.state.time}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default QuestionPreview
